import React from 'react';

var usePreventDefaultHandlers = function usePreventDefaultHandlers(handlers) {
  return React.useMemo(function () {
    return handlers.map(function (handler) {
      return handler ? function (e) {
        if (e && typeof e.preventDefault === 'function') {
          e.preventDefault();
        }

        for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          rest[_key - 1] = arguments[_key];
        }

        handler.apply(void 0, [e].concat(rest));
      } : undefined;
    });
  }, [handlers]);
};

export default usePreventDefaultHandlers;
//# sourceMappingURL=index.js.map